import { rem } from './../functions/units';
import { rgba } from './../functions/conversion';
import colors from './colors';
var shadows = {
  xs: rem(0, 2, 6, 0) + ' ' + rgba(colors.blackDeep, 0.2),
  sm: rem(0, 4, 8) + ' ' + rgba(colors.blackDeep, 0.15),
  md: rem(0, 8, 16) + ' ' + rgba(colors.blackDeep, 0.1),
  lg: rem(0, 16, 24) + ' ' + rgba(colors.blackDeep, 0.1)
};
export default shadows;